import * as R from 'ramda';

import { FormAssetErrors } from '@atom/types/form';
import {
  AttributesType,
  HydratedAttributeGroupsItem,
} from '@atom/types/schema';

import InstanceAttributeField from './InstanceAttributeField';

import classes from '../formInstance.module.css';

interface PassedProps {
  attributeGroup: HydratedAttributeGroupsItem;
  isEditable: boolean;
  assetId: string;
  fieldId: string;
  progressiveUpdateFormInstanceAttribute: (
    fieldId: string,
    assetId: string,
    attributeGroupName: string,
    attributeId: string,
    body: Object,
  ) => void;
  savingFormInstance: boolean;
  assetErrors?: FormAssetErrors;
}

type Props = PassedProps;

const InstanceAttributeGroup = ({
  attributeGroup,
  assetId,
  fieldId,
  isEditable,
  progressiveUpdateFormInstanceAttribute,
  savingFormInstance,
  assetErrors,
}: Props) => {
  const attributes = R.pathOr([], ['attributes'], attributeGroup);

  return (
    <div key={attributeGroup.name} className={classes.attributeGroupBlock}>
      <div className={classes.attributeGroupName}>{attributeGroup.name}</div>
      {attributes.map((attribute: AttributesType) => (
        <InstanceAttributeField
          isEditable={isEditable}
          key={attribute.id}
          attribute={attribute}
          attributeGroupName={attributeGroup.name}
          assetId={assetId}
          fieldId={fieldId}
          progressiveUpdateFormInstanceAttribute={
            progressiveUpdateFormInstanceAttribute
          }
          savingFormInstance={savingFormInstance}
          assetErrors={assetErrors}
        />
      ))}
    </div>
  );
};

export default InstanceAttributeGroup;
